export default __webpack_public_path__ + "static/media/electricpowerguide.0e11ed62.pdf";